// extracted by mini-css-extract-plugin
export default {"hero":"Home_hero__vIbQD","heroContent":"Home_heroContent__DJZaF"};